import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { get, getWithParams, post } from "../../utils/fetchAPI";

const initialState = {
    prescriptionId: '',
    templateDetails: {},
    medicineList: [],
    isNoMedicine: false,
    isMedicineListLoading: false,
    doctorMedicineList: [],
    isDoctorMedicineListLoading: false,
    isLoading: false,
    isOperationLoading: false,
    error: null,
    labTestList: [],
    isLabTestListLoading: false,
    adviceList: [],
    templateList:[],
    isAdviceListLoading: false
};

export const getTemplateDetails = createAsyncThunk(
    "template/getTemplateDetails",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getWithParams(`/doctor/template/${payload?.templateId}`, { doctorId: payload.doctorId });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const getAllMedicineList = createAsyncThunk(
    "template/getAllMedicineList",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getWithParams(`/medicine-list?key=${payload?.key}&search=${payload?.search}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const getDoctorMedicineList = createAsyncThunk(
    "template/getDoctorMedicineList",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await get(`/doctor/frequent-medicine-list/${payload?.doctorId}?search=${payload?.search}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const getAllLabTests = createAsyncThunk(
    "template/getAllLabTests",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getWithParams(`/lab-test-list/${payload?.doctorId}?search=${payload?.search || ""}&groupId=${payload?.groupId || ""}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const getAllAdvices = createAsyncThunk(
    "template/getAllAdvices",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getWithParams(`/doctor/advice-list/${payload?.doctorId}?search=${payload?.search || ""}&groupId=${payload?.groupId || ""}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const getTemplateList = createAsyncThunk(
    "template/getTemplateList",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getWithParams(`/doctor/template/list/${payload?.doctorId}?search=${payload?.search}&per_page=100&current_page=1`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);



const templateSlice = createSlice({
    name: "template",
    initialState,
    reducers: {

    },
    extraReducers: {
        [getTemplateDetails.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            // state.templateDetails = [];
            // state.prescriptionId = ''
        },
        [getTemplateDetails.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.templateDetails = action.payload;
            // state.prescriptionId = action.payload[0]?._id
            state.pagination = action.payload.rest;
            state.error = null;
        },
        [getTemplateDetails.rejected]: (state, action) => {
            state.isLoading = false;
            state.error = action.payload?.message;
        },

        [getAllMedicineList.pending]: (state) => {
            state.isMed = true;
            state.error = null;
            state.isMedicineListLoading = true;
            state.medicineList = [];
            state.isNoMedicine = false
        },
        [getAllMedicineList.fulfilled]: (state, action) => {

            state.medicineList = action.payload;
            if (action.payload.length == 0)
                state.isNoMedicine = true
            state.isMedicineListLoading = false;
            state.error = null;
        },
        [getAllMedicineList.rejected]: (state, action) => {
            state.isMedicineListLoading = false;
            state.error = action.payload?.message;
        },

        [getDoctorMedicineList.pending]: (state) => {
            state.isMed = true;
            state.error = null;
            state.isDoctorMedicineListLoading = true;
            // state.medicineList = [];
        },
        [getDoctorMedicineList.fulfilled]: (state, action) => {

            state.doctorMedicineList = action.payload;
            state.isDoctorMedicineListLoading = false;
            state.error = null;
        },
        [getDoctorMedicineList.rejected]: (state, action) => {
            state.isDoctorMedicineListLoading = false;
            state.error = action.payload?.message;
        },
        [getAllLabTests.pending]: (state) => {
            state.isMed = true;
            state.error = null;
            state.isLabTestListLoading = true;
        },
        [getAllLabTests.fulfilled]: (state, action) => {

            state.labTestList = action.payload;
            state.isLabTestListLoading = false;
            state.error = null;
        },
        [getAllLabTests.rejected]: (state, action) => {
            state.isLabTestListLoading = false;
            state.error = action.payload?.message;
        },

        [getAllAdvices.pending]: (state) => {
            state.isMed = true;
            state.error = null;
            state.isAdviceListLoading = true;
        },
        [getAllAdvices.fulfilled]: (state, action) => {

            state.adviceList = action.payload;
            state.isAdviceListLoading = false;
            state.error = null;
        },
        [getAllAdvices.rejected]: (state, action) => {
            state.isLabTestListLoading = false;
            state.error = action.payload?.message;
        },

        [getTemplateList.pending]: (state) => {
            state.error = null;
            state.isLoading = true;
        },
        [getTemplateList.fulfilled]: (state, action) => {

            state.templateList = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        [getTemplateList.rejected]: (state, action) => {
            state.isLoading = false;
            state.error = action.payload?.message;
        },
    },
});

export default templateSlice.reducer;
// export const { resetAllPatients } = patientSlice.actions;
